export const dmsRouteDef = [

    {
        path: ':id/:resource/dicomviewer',
        component: 'DiacomViewerComponent',
        data: {
            selector: 'diacom-viewer',
            config: {
                type:"file",
                datasource: {
                    "application": "dms",
                    "resource": "dicom/image-response-entity",                
                    "args": "id:!!!id!!!",
                    "queryId": "GET_DICOM"
                }
            }
        }
    },

 ]